import React from "react";
import {observer} from "mobx-react";
import { LottieAnimatedTopImageComponent } from "./lottie-animated-top-image.component";
import {PixiAnimatedTopImageComponent} from "./pixi-animated-top-image.component";
import {AnimatedTopImageConfiguration} from "../../services/configurations/config-data-sections/arenas.configuration";
import {OrbitComponentWithState} from "../base-components/orbit-component-with-state/orbit-component-with-state";
import {Check} from "@sparkware/app-utils";


export interface AnimatedTopImageComponentProps {
    imageAnimationConfig: AnimatedTopImageConfiguration;
    delay?: number;
    onAnimationStart?: () => void;
}

interface AnimatedTopImageComponentState {
    playAnimation: boolean;
}

@observer
export class AnimatedTopImageComponent extends OrbitComponentWithState<AnimatedTopImageComponentProps, AnimatedTopImageComponentState> {
    constructor(props) {
        super(props);
        this.state = {
            playAnimation: !(Check.isNumber(props.delay) && props.delay > 0)
        }
    }

    componentDidMount() {
        super.componentDidMount();
        if (Check.isNumber(this.props.delay) && this.props.delay > 0) {
            setTimeout(() => {
                this.setState({
                   playAnimation: true
                });
            }, this.props.delay);
        }
    }

    render() {
        if (!this.state.playAnimation) {
            return null;
        }

        if (this.props.imageAnimationConfig.engine === "pixi") {
            return <PixiAnimatedTopImageComponent image={this.props.imageAnimationConfig.url} />
        }
        return <LottieAnimatedTopImageComponent onAnimationStart={this.props.onAnimationStart} image={this.props.imageAnimationConfig.url} />
    }
}